(() => {
  'use strict';
  const selector = '[data-add-to-cart], [data-sticky-add]';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const targets = new Map();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = targets.get(entry.target);
      if (state) state.visible = entry.isIntersecting && entry.intersectionRatio >= .15;
    }
    sync();
  }, { threshold: [0, .15] }) : null;
  const mutations = new MutationObserver(sync);

  function sync() {
    const quiet = document.hidden || reduced.matches || Boolean(connection?.saveData) || Boolean(document.querySelector('dialog[open]'));
    for (const [button, state] of targets) {
      const blocked = button.disabled || button.getAttribute('aria-busy') === 'true' || button.classList.contains('is-adding') || Boolean(button.closest('[hidden], [inert]'));
      button.classList.toggle('kn-atc-motion', !quiet && !blocked && state.visible);
    }
  }

  function mount() {
    for (const [button] of targets) {
      if (!button.isConnected) { observer?.unobserve(button); targets.delete(button); }
    }
    document.querySelectorAll(selector).forEach(button => {
      if (targets.has(button)) return;
      targets.set(button, { visible: false });
      observer?.observe(button);
    });
    mutations.disconnect();
    for (const [button] of targets) mutations.observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    document.querySelectorAll('[data-sticky], dialog').forEach(node => mutations.observe(node, { attributes: true, attributeFilter: ['hidden', 'inert', 'open'] }));
    sync();
  }
  reduced.addEventListener('change', sync);
  connection?.addEventListener?.('change', sync);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(mount));
  window.addEventListener('pagehide', () => { for (const [button] of targets) button.classList.remove('kn-atc-motion'); });
  window.addEventListener('pageshow', sync);
  mount();
})();
